var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumTimer1 = function SvgNumTimer1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3",
    d: "M6.74 11.576H3.956V7.52h7.584V29h-4.8z"
  })));
};
export default SvgNumTimer1;